import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center border-b border-context-6 p-4 font-normal" }
const _hoisted_2 = { class: "mb-5 flex flex-col items-center justify-center" }
const _hoisted_3 = { class: "flex flex-col items-center gap-1" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "mb-0 flex items-center" }
const _hoisted_6 = { class: "flex items-center gap-2" }
const _hoisted_7 = { class: "flex items-center gap-1" }
const _hoisted_8 = { class: "t3" }
const _hoisted_9 = { class: "flex items-center gap-1" }
const _hoisted_10 = {
  key: 0,
  class: "flex gap-1"
}
const _hoisted_11 = {
  key: 2,
  class: "flex gap-2"
}
const _hoisted_12 = { class: "t3 m-0" }
const _hoisted_13 = { class: "select-none" }
const _hoisted_14 = ["title"]
const _hoisted_15 = { class: "relative mt-1" }

import { ref, computed } from 'vue'
import { $date } from '@/plugins'
import i18n from '@/scripts/app-configs/i18n-config'
import PatientAttentionLevel from '@/components/patient/PatientAttentionLevel.vue'
import GutenbergHighlight from '@/components/micro/GutenbergHighlight.vue'
import QuickAction from '@/components/inputs/QuickAction.vue'
import { QUICK_ACTIONS_CONFIG } from '@/components/drawers/MemberDrawer/constants/quick-actions-config'
import type { Profile, Eligibility, Context } from '@/components/drawers/MemberDrawer/types/member-drawer.types'

interface HeaderProps {
  profile: Profile
  age?: number | string,
  currentState: string | null
  eligibility: Eligibility
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MemberDrawerContentHeader',
  props: {
    profile: {},
    age: {},
    currentState: {},
    eligibility: {}
  },
  emits: ["copy-to-clipboard", "open-ui", "send-to-user"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const attentionLevel = ref(props.profile.member_attention_level)

const currentStateDetails = computed(() => {
  return {
    cssClass: props.currentState
      ? `patient-state-${props.currentState.replace(/_/g, '-')}`
      : 'patient-state-unknown',
    copy: props.currentState ? `patient_state_${props.currentState}` : '-',
  }
})

const quickActions = QUICK_ACTIONS_CONFIG.filter((action) => !action.disabled)

const getChipTitle = () => {
  if (props.profile.remaining_days_in_on_hold === 0) {
    return i18n.t('LATEST_ACTIVITY.TODAY')
  }

  return i18n.t('n_days_left', { daysleft: props.profile.remaining_days_in_on_hold })
}

const handleClickAction = (action: string) => {
  const context = action.replace(/^[a-z]+-/, '') as Context

  switch (action) {
    case 'open-notes':
    case 'open-sword-desk':
      emit('open-ui', { context })
      break
    case 'copy-reassessment-link':
    case 'copy-ob-call-link':
    case 'copy-check-in-link':
      emit('copy-to-clipboard', { context })
      break
    case 'send-reassessment-link':
    case 'send-check-in-link':
      emit('send-to-user', { context })
      break
    default:
      break
  }
}

const copyToClipboard = (content: string) => {
  emit('copy-to-clipboard', { context: 'member-id', content })
}

return (_ctx: any,_cache: any) => {
  const _component_profile_picture = _resolveComponent("profile-picture")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_chip_wuk = _resolveComponent("chip-wuk")!
  const _component_hover_to_copy = _resolveComponent("hover-to-copy")!
  const _component_sword_tag = _resolveComponent("sword-tag")!
  const _component_sword_icon = _resolveComponent("sword-icon")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "rounded-full border border-transparent transition-colors duration-200 ease-in-out hover:border-primary",
        to: `/patients/${__props.profile.user_id}/board`,
        target: "_blank",
        rel: "noreferrer noopener"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_profile_picture, {
            gender: __props.profile.gender,
            "show-vip-icon": __props.profile.is_vip_account,
            "show-high-risk-icon": __props.profile.patient_is_high_risk,
            "show-gender-icon": !!__props.profile.gender,
            picture: __props.profile.picture,
            class: "!size-16"
          }, null, 8, ["gender", "show-vip-icon", "show-high-risk-icon", "show-gender-icon", "picture"])
        ], undefined, true),
        _: 1
      }, 8, ["to"])
    ]),
    _createVNode(PatientAttentionLevel, {
      modelValue: attentionLevel.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((attentionLevel).value = $event)),
      "patient-id": __props.profile.user_id,
      class: "mb-2",
      editable: ""
    }, null, 8, ["modelValue", "patient-id"]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (__props.profile.gutenberg_flag)
          ? (_openBlock(), _createBlock(GutenbergHighlight, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_5, [
          _createVNode(_component_router_link, {
            class: "text-inherit hover:text-primary",
            to: `/patients/${__props.profile.user_id}/board`,
            target: "_blank",
            rel: "noreferrer noopener"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`${__props.profile.firstname} ${__props.profile.lastname}`), 1)
            ], undefined, true),
            _: 1
          }, 8, ["to"]),
          (!!__props.age)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "dot-separator mx-2" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("copy_1288")) + " " + _toDisplayString(__props.age), 1)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", {
            class: _normalizeClass(["size-1.5 rounded-full", `${currentStateDetails.value.cssClass}-bg`])
          }, null, 2),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(currentStateDetails.value.copy)), 1),
          (__props.profile.remaining_days_in_on_hold !== null)
            ? (_openBlock(), _createBlock(_component_chip_wuk, {
                key: 0,
                title: getChipTitle,
                color: "primary",
                rounded: "",
                bold: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.profile.remaining_days_in_on_hold) + "d ", 1)
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "dot-separator" }, null, -1)),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("copy_4331")), 1),
          _createVNode(_component_hover_to_copy, { onOnCopy: copyToClipboard }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.profile.user_id), 1)
            ], undefined, true),
            _: 1
          })
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "dot-separator" }, null, -1)),
        _createElementVNode("div", null, [
          _createElementVNode("span", null, _toDisplayString(__props.profile.institution_name), 1)
        ])
      ]),
      (__props.eligibility.aso_name)
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.$t("member_info.aso_group")) + " " + _toDisplayString(__props.eligibility.aso_name), 1))
        : _createCommentVNode("", true),
      (!!__props.profile.has_pending_exclusion_requests)
        ? (_openBlock(), _createBlock(_component_sword_tag, {
            key: 1,
            color: "neutral",
            size: "sm"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('SIDEBAR.PENDING_EXCLUSION')), 1)
            ], undefined, true),
            _: 1
          }))
        : _createCommentVNode("", true),
      (__props.profile.screened_at && _unref($date)(__props.profile.screened_at).isValid())
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_sword_icon, { name: "calendar" }),
            _createElementVNode("p", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('patient_state_enrolled')) + ": ", 1),
              _createElementVNode("span", {
                title: _unref($date)(__props.profile.screened_at).format('llll')
              }, _toDisplayString(_unref($date)(__props.profile.screened_at).format('MMM D')), 9, _hoisted_14),
              _createElementVNode("span", null, ", " + _toDisplayString(_unref($date)().defaultDiff(__props.profile.screened_at)), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(quickActions), (action, key) => {
          return (_openBlock(), _createBlock(QuickAction, {
            key: `quick-action-${key}`,
            "action-key": action.key,
            icon: action.icon,
            tooltip: action.tooltip,
            options: action.options,
            onAction: handleClickAction
          }, null, 8, ["action-key", "icon", "tooltip", "options"]))
        }), 128))
      ])
    ])
  ]))
}
}

})